define('flight-components/mixins/withUrlState',['require','URIjs/URI'],function(require){

  var URI = require('URIjs/URI');

  function withUrlState() {

    var checkedState = false;

    this.defaultAttrs({
      checkUrlState: true,
      states: {
        'cpncode' : 'viewCouponCodeListing',
        'printnow' : 'viewBppListing'
      }
    });

    // Trigger state event when one of `states` is in current URL params
    //
    this.checkUrlState = function() {

      if (!this.attr.checkUrlState || checkedState) return;

      checkedState = true;

      var uri = URI(window.location.href);
      var query = uri.query(true);
      for (param in query) {
        if (this.attr.states.hasOwnProperty(param)) {
          this.trigger(this.attr.states[param], {
            state: param,
            name: this.attr.states[param],
            params: query
          });
          break;
        }
      }
    };

    this.after('initialize', function() {

    });

  };

  return withUrlState;

});
